import Download from '@mui/icons-material/Download'
import Edit from '@mui/icons-material/Edit'
import { Button, CircularProgress, Dialog } from '@mui/material'

import dayjs from 'dayjs'
import { useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { MOMENT_FORMATS, REPORT_DATE_TYPES, REPORT_DATE_TYPES_ARRAY } from 'src/consumer/constants'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams } from 'src/mentor/services'
import {
  ProfileTabButton,
  ProfileTabButtonContainer,
} from '../../MentorProfilePage/MentorProfilePageStyles'
import ClinicReportComponent from './components/ClinicReportComponent'
import CumulativeBrandReports from './components/CumulativeBrandReports'
import CustomTimeRangeComponent from './components/CustomTimeRangeComponent'
import { ReportsContainer } from './styledComponents'
import {
  fetchClinicBrandReportsForOwner,
  getCorrectReportDateStringForClinicLocationReports,
  getCumulativeClinicBrandReportFromClinicReports,
} from './utils'
export default function ClinicReportsPage({
  associatedClinicBrands,
  associatedClinics,
  loadingAssociationsData,
  hideMainHeading = false,
}) {
  const [allClinicLocations, setAllClinicLocations] = useState([])
  const [allClinicBrands, setAllClinicBrands] = useState([])
  const [selectedClinicBrand, setSelectedClinicBrand] = useState(null)
  const [reports, setReports] = useState()
  const [reportType, setReportType] = useState(REPORT_DATE_TYPES.day)
  const [customStartTime, setCustomStartTime] = useState()
  const [customEndTime, setCustomEndTime] = useState()

  const [cumulatedClinicBrandReport, setCumulatedClinicBrandReport] = useState(null)
  const [allScreeners, setAllScreeners] = useState([])

  const [showCustomTimeRangeReports, setShowCustomTimeRangeReportsDialog] = useState(false)

  const [loading, setLoading] = useState({
    clinics: true,
    clinicBrands: true,
    reports: true,
  })

  const [hideReports, setHideReports] = useState(false)

  const downloadButtonsRef = useRef({})

  async function fetchReports(startTime, endTime) {
    console.log({ selectedClinicBrand })

    return await fetchClinicBrandReportsForOwner({
      selectedClinicBrandId: selectedClinicBrand?.id,
      startTime,
      endTime,
    })
  }

  async function getAllScreenersInClinicBrand() {
    const mentorRespData = await getMPDataWithParams(
      '/api/secure/clinic-admin/mentor/screener/list/all',
      {
        clinicBrandId: selectedClinicBrand?.id,
      },
    )
    if (mentorRespData?.status === 200) {
      if (isCommonResponseSuccessful(mentorRespData?.data?.code)) {
        console.log({ mentorRespData })
        setAllScreeners(mentorRespData?.data?.data?.screeners)
      }
    }
  }

  async function fetchAllClinicsInClinicBrand() {
    setLoading((prev) => ({ ...prev, clinics: true }))
    const detailedClinics = associatedClinics?.filter(
      (clinic) => clinic?.clinicBrandId === selectedClinicBrand?.id,
    )
    setAllClinicLocations(detailedClinics)
    // await getAllScreenersInClinics(detailedClinics)
    setLoading((prev) => ({ ...prev, clinics: false }))
  }

  async function fetchAllClinicBrands() {
    setLoading((prev) => ({ ...prev, clinicBrands: true }))
    console.log('fetchAllClinicBrands - associatedClinicBrands:', associatedClinicBrands)
    setAllClinicBrands(associatedClinicBrands || [])
    setLoading((prev) => ({ ...prev, clinicBrands: false }))
  }

  async function submitTimeRange(stTime, enTime) {
    setCustomStartTime(stTime)
    setCustomEndTime(enTime)

    setLoading((prev) => ({
      ...prev,
      reports: true,
    }))
    setShowCustomTimeRangeReportsDialog(false)
    setReportType('custom')

    const startTime = dayjs.utc(stTime).format(MOMENT_FORMATS.javaInstantFormat)
    const endTime = dayjs.utc(enTime).format(MOMENT_FORMATS.javaInstantFormat)

    const reports = await fetchReports(startTime, endTime)

    const allReports = [{ startTime, endTime, ...(reports || {}) }]
    setReports(allReports)
    if (allReports?.some((report) => report?.axiosStatus === 403)) {
      toast.error('You are not authorized to view these reports')

      setHideReports(true)

      setLoading((prev) => ({
        ...prev,
        reports: false,
      }))
      return
    }

    setReports(allReports)

    const cumulatedClinicBrandReport = getCumulativeClinicBrandReportFromClinicReports(allReports)
    setCumulatedClinicBrandReport(cumulatedClinicBrandReport)

    console.log({ cumulatedClinicBrandReport })
    setHideReports(false)
    setLoading((prev) => ({
      ...prev,
      reports: false,
    }))
  }

  async function fetchPrevious7YearsReport() {
    const today = dayjs().endOf('year').utc().format(MOMENT_FORMATS.javaInstantFormat)

    console.log({ thisYear: today })

    const reports = await Promise.all(
      Array.from({ length: 7 }).map(async (_, index) => {
        const endTime = dayjs
          .utc(today)
          .subtract(index, 'year')
          .format(MOMENT_FORMATS.javaInstantFormat)
        const startTime = dayjs
          .utc(today)
          .subtract(index + 1, 'year')
          .format(MOMENT_FORMATS.javaInstantFormat)

        const reports = await fetchReports(startTime, endTime)
        return { startTime, endTime, ...(reports || {}) }
      }),
    )
    return reports
  }

  async function fetchPrevious7MonthReport() {
    const today = dayjs().endOf('month').utc().format(MOMENT_FORMATS.javaInstantFormat)
    console.log({ thisMOnth: today })

    const reports = await Promise.all(
      Array.from({ length: 7 }).map(async (_, index) => {
        const endTime = dayjs
          .utc(today)
          .subtract(index, 'month')
          .format(MOMENT_FORMATS.javaInstantFormat)
        const startTime = dayjs
          .utc(today)
          .subtract(index + 1, 'month')
          .format(MOMENT_FORMATS.javaInstantFormat)

        const reports = await fetchReports(startTime, endTime)
        return { startTime, endTime, ...(reports || {}) }
      }),
    )
    console.log({ fetchedReports: reports })
    return reports
  }

  async function fetchPrevious7WeeksReports() {
    const today = dayjs().endOf('week').utc().format(MOMENT_FORMATS.javaInstantFormat)
    const reports = await Promise.all(
      Array.from({ length: 7 }).map(async (_, index) => {
        const endTime = dayjs
          .utc(today)
          .subtract(index, 'week')
          .format(MOMENT_FORMATS.javaInstantFormat)
        const startTime = dayjs
          .utc(today)
          .subtract(index + 1, 'week')
          .format(MOMENT_FORMATS.javaInstantFormat)

        const reports = await fetchReports(startTime, endTime)
        return { startTime, endTime, ...(reports || {}) }
      }),
    )
    console.log({ fetchedReports: reports })
    return reports
  }

  async function fetchPrevious7DaysReports() {
    const today = dayjs().endOf('day').utc().format(MOMENT_FORMATS.javaInstantFormat)
    const reports = await Promise.all(
      Array.from({ length: 7 }).map(async (_, index) => {
        const endTime = dayjs
          .utc(today)
          .subtract(index, 'days')
          .format(MOMENT_FORMATS.javaInstantFormat)
        const startTime = dayjs
          .utc(today)
          .subtract(index + 1, 'days')
          .format(MOMENT_FORMATS.javaInstantFormat)

        const reports = await fetchReports(startTime, endTime)
        return { startTime, endTime, ...(reports || {}) }
      }),
    )
    console.log({ fetchedReports: reports })
    return reports
  }

  async function fetchReportsBasedOnReportType(repType) {
    setLoading((prev) => ({
      ...prev,
      reports: true,
    }))

    var allReports = null
    if (repType === REPORT_DATE_TYPES.day) {
      const reports = await fetchPrevious7DaysReports()
      allReports = reports
    }
    if (repType === REPORT_DATE_TYPES.week) {
      const reports = await fetchPrevious7WeeksReports()
      allReports = reports
    }
    if (repType === REPORT_DATE_TYPES.month) {
      const reports = await fetchPrevious7MonthReport()
      allReports = reports
    }
    if (repType === REPORT_DATE_TYPES.year) {
      const reports = await fetchPrevious7YearsReport()
      allReports = reports
    }

    if (allReports?.some((report) => report?.axiosStatus === 403)) {
      toast.error('You are not authorized to view these reports')

      setHideReports(true)

      setLoading((prev) => ({
        ...prev,
        reports: false,
      }))
      return
    }

    setReports(allReports)

    const cumulatedClinicBrandReport = getCumulativeClinicBrandReportFromClinicReports(allReports)
    setCumulatedClinicBrandReport(cumulatedClinicBrandReport)

    console.log({ cumulatedClinicBrandReport })
    setHideReports(false)
    setLoading((prev) => ({
      ...prev,
      reports: false,
    }))
  }

  function getCorrectReportDateString(dayjsReportDate) {
    return getCorrectReportDateStringForClinicLocationReports({
      dayjsReportDate,
      reportType,
    })
  }

  function closeCustomTimeReports() {
    setShowCustomTimeRangeReportsDialog(false)
  }

  function showCustomTimeReports() {
    setShowCustomTimeRangeReportsDialog(true)
  }

  function downloadAllReports() {
    console.log({ downloadButtonsRef })
    Object.values(downloadButtonsRef.current).forEach((btnRef) => {
      btnRef.click()
    })
  }

  const enabledClinicBrands = useMemo(() => {
    // Show all brands unless explicitly disabled (enabled === false)
    // This treats undefined/null as enabled
    const filtered = Array.isArray(allClinicBrands)
      ? allClinicBrands
      : []
      .filter((clinicBrand) => {
        // Include if enabled is not explicitly false
        const isEnabled = clinicBrand?.enabled !== false
        return isEnabled
      })
      .sort((a, b) => (a?.title || a?.brandName || '')?.localeCompare(b?.title || b?.brandName || ''))
    console.log('ClinicReportsPage - allClinicBrands:', allClinicBrands)
    console.log('ClinicReportsPage - enabledClinicBrands:', filtered)
    console.log('ClinicReportsPage - associatedClinicBrands:', associatedClinicBrands)
    return filtered
  }, [allClinicBrands, associatedClinicBrands])

  const availableClinicBrands = useMemo(() => {
    if (enabledClinicBrands.length > 0) return enabledClinicBrands
    if (Array.isArray(associatedClinicBrands) && associatedClinicBrands.length > 0) {
      return associatedClinicBrands
    }
    return []
  }, [enabledClinicBrands, associatedClinicBrands])

  const isLoadingBrands = loadingAssociationsData || loading.clinicBrands

  useEffect(() => {
    fetchAllClinicBrands()
    fetchAllClinicsInClinicBrand()
  }, [associatedClinicBrands, associatedClinics])

  useEffect(() => {
    // Set the first enabled clinic brand as selected if none is selected
    if (!selectedClinicBrand && availableClinicBrands.length > 0) {
      setSelectedClinicBrand(availableClinicBrands[0])
    }
  }, [availableClinicBrands, selectedClinicBrand])

  useEffect(() => {
    if (!!selectedClinicBrand) {
      fetchAllClinicsInClinicBrand()
      getAllScreenersInClinicBrand()
    }
  }, [selectedClinicBrand])

  useEffect(() => {
    if (!!selectedClinicBrand) {
      if (reportType === 'custom') {
        submitTimeRange(customStartTime, customEndTime)
      } else {
        fetchReportsBasedOnReportType(reportType)
      }
    }
  }, [selectedClinicBrand])

  useEffect(() => {
    console.log({ allClinicLocations })
  }, [allClinicLocations])

  return (
    <div className="d-flex flex-column gap-2 py-3">
      {!hideMainHeading && <h2>Stats</h2>}
      {!isLoadingBrands && availableClinicBrands.length === 0 && (
        <div className="alert alert-info">
          {associatedClinicBrands?.length > 0
            ? `No enabled clinic brands available. Found ${associatedClinicBrands.length} brand(s) but all are disabled. Please contact support to enable your clinic brands.`
            : 'No clinic brand available. Please ensure you are associated with a clinic brand.'}
        </div>
      )}
      {!isLoadingBrands && allClinicBrands?.length > 0 && availableClinicBrands.length === 0 && (
        <div className="alert alert-warning mt-2">
          <strong>Debug Info:</strong> Found {allClinicBrands.length} brand(s) but none passed the enabled filter.
          <br />
          Brands: {JSON.stringify(allClinicBrands.map((b) => ({ id: b?.id, title: b?.title || b?.brandName, enabled: b?.enabled })))}
        </div>
      )}
      <CustomSelect
        id="clinicBrand"
        label="Clinic Brand"
        value={selectedClinicBrand}
        options={availableClinicBrands}
        isLoading={isLoadingBrands}
        getOptionValue={(optn) => optn?.id}
        getOptionLabel={(optn) => optn?.title || optn?.brandName}
        onChangeEvent={(e) => {
          setSelectedClinicBrand(e.target.value)
        }}
        selectType={selectTypes.object}
      />
      {!!selectedClinicBrand && allClinicLocations.length > 0 && (
        <>
          <ProfileTabButtonContainer sx={{ zIndex: 1 }} className="justify-content-start gap-2">
            {REPORT_DATE_TYPES_ARRAY?.map((repType, idx) => (
              <ProfileTabButton
                key={repType?.id}
                selected={repType.id === reportType}
                onClick={() => {
                  setReportType(repType.id)
                  fetchReportsBasedOnReportType(repType?.id)
                }}
              >
                Last 7 {repType.title}s
              </ProfileTabButton>
            ))}
            <ProfileTabButton
              selected={reportType === 'custom'}
              onClick={() => {
                showCustomTimeReports(true)
              }}
            >
              Custom Period {reportType === 'custom' && <Edit />}
            </ProfileTabButton>
          </ProfileTabButtonContainer>
          {loading?.reports ? (
            <CircularProgress />
          ) : (
            <>
              {!hideReports && (
                <ReportsContainer className="mb-3">
                  <div className="d-flex align-items-center justify-content-end">
                    <Button
                      onClick={downloadAllReports}
                      endIcon={<Download />}
                      sx={{ mb: 3, textTransform: 'unset !important' }}
                    >
                      Download All
                    </Button>
                  </div>
                  <CumulativeBrandReports
                    entityTitle={selectedClinicBrand?.title || selectedClinicBrand?.brandName}
                    reportType={reportType}
                    reports={cumulatedClinicBrandReport}
                    screeners={allScreeners}
                    allClinicLocations={allClinicLocations}
                    defaultExpanded
                    downloadButtonRef={downloadButtonsRef}
                  />
                  {allClinicLocations?.map((clinicLocation) => (
                    <ClinicReportComponent
                      key={clinicLocation.id}
                      clinicLocation={clinicLocation}
                      allReports={reports}
                      reportType={reportType}
                      downloadButtonRef={downloadButtonsRef}
                      getCorrectReportDateString={getCorrectReportDateString}
                      allScreeners={allScreeners}
                    />
                  ))}
                </ReportsContainer>
              )}
            </>
          )}
        </>
      )}
      <Dialog open={showCustomTimeRangeReports} onClose={closeCustomTimeReports}>
        <CustomTimeRangeComponent
          submitTimeRange={submitTimeRange}
          closeDialog={closeCustomTimeReports}
        />
      </Dialog>
    </div>
  )
}
